module.exports = __webpack_public_path__ + "img/pic_bt_cn.0fb5944b.png";